import AddressTypeahead from './dom';
export default AddressTypeahead;
